import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea24b514"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-menu" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("专栏")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("书签")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("网址")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("管理")

import { computed, ref } from "vue";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const currentRoute = computed(() => store.state.common.currentRoute);
const isOwner = computed(() => store.state.common.isOwner);

function routerActive(router: string): string {
  return currentRoute.value === router ? "router-active" : "";
}

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(routerActive('/home')),
          to: "/home"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, { name: "home" }),
            _hoisted_2
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(routerActive('/column')),
          to: "/column"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, { name: "column" }),
            _hoisted_3
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(routerActive('/collection')),
          to: "/collection"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, { name: "collection" }),
            _hoisted_4
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(routerActive('/tool')),
          to: "/tool"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, { name: "tool" }),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      (_unref(isOwner))
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(routerActive('/manage')),
              to: "/manage"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, { name: "manage" }),
                _hoisted_7
              ]),
              _: 1
            }, 8, ["class"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})